/* koréos C homepage behaviour (build agent H): hero tabs, shelf tabs (lazy panels), Pumpoo scent switch, "Add all", store open-now, read more.
   Every init is idempotent (data-kh-ready) so the theme editor's section reloads work. No autoplay anywhere. */
(function () {
  if (window.kcHome) return;
  var d = document;
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function once(el) { if (el.dataset.khReady) return false; el.dataset.khReady = '1'; return true; }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function previewParam() {
    try { var t = window.Shopify && Shopify.theme; if (t && t.role && t.role !== 'main') return '&preview_theme_id=' + t.id; } catch (e) {}
    return '';
  }

  function tablist(tl, onSelect) {
    var tabs = $$('[role="tab"]', tl);
    function sel(t, focus) {
      tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; });
      if (focus) t.focus();
      onSelect(t, tabs.indexOf(t));
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { sel(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); sel(tabs[(i + 1) % tabs.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); sel(tabs[(i - 1 + tabs.length) % tabs.length], true); }
      });
    });
    return sel;
  }

  function loadSlide(s) {
    $$('source[data-srcset]', s).forEach(function (x) { x.srcset = x.dataset.srcset; x.removeAttribute('data-srcset'); });
    $$('img[data-src]', s).forEach(function (im) { if (im.dataset.srcset) { im.srcset = im.dataset.srcset; im.removeAttribute('data-srcset'); } im.src = im.dataset.src; im.removeAttribute('data-src'); });
  }

  function hero(h) {
    if (!once(h)) return;
    var slides = $$('.kh-hero__slide', h), art = h.querySelector('.kh-hero__art'), tl = h.querySelector('[role="tablist"]');
    if (!tl || slides.length < 2) return;
    function go(i) {
      loadSlide(slides[i]);
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
      if (slides[i].dataset.bg) art.style.setProperty('--slide-bg', slides[i].dataset.bg);
      $$('[data-slide-card]', h).forEach(function (c) { var on = +c.dataset.slideCard === i; c.classList.toggle('is-on', on); if (on) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true'); });
    }
    var sel = tablist(tl, function (t, i) { go(i); });
    var tabs = $$('[role="tab"]', tl), x0 = null;
    art.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    art.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) < 40) return;
      var cur = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      sel(tabs[(cur + (dx < 0 ? 1 : -1) + tabs.length) % tabs.length]);
    }, { passive: true });
    var later = function () { slides.slice(1).forEach(loadSlide); };
    if (d.readyState === 'complete') setTimeout(later, 1500); else window.addEventListener('load', function () { setTimeout(later, 1500); });
  }

  function shelf(s) {
    if (!once(s)) return;
    var tl = s.querySelector('[role="tablist"]'); if (!tl) return;
    var all = s.querySelector('[data-shelf-all]');
    tablist(tl, function (t) {
      $$('.kh-panel', s).forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
      var p = d.getElementById(t.getAttribute('aria-controls'));
      if (all && t.dataset.url) { all.href = t.dataset.url; all.querySelector('span').textContent = t.dataset.all; }
      if (p && p.dataset.src && !p.dataset.loaded) {
        p.dataset.loaded = '1'; p.classList.add('is-loading'); p.setAttribute('aria-busy', 'true');
        fetch(p.dataset.src + previewParam(), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'), g = doc.querySelector('.kh-grid4');
          if (!g) throw new Error('no grid');
          var grid = p.querySelector('.kh-grid4');
          grid.innerHTML = '';
          // nodes parsed by DOMParser must be imported so customized built-ins (form is="product-form") upgrade
          $$('.kc-card', g).forEach(function (c) { grid.insertAdjacentHTML('beforeend', c.outerHTML); });
        }).catch(function () { delete p.dataset.loaded; var a = d.createElement('p'); a.className = 'kh-note'; a.innerHTML = '<a class="kh-shead__all" href="' + (t.dataset.url || '#') + '">' + (t.dataset.all || 'Shop all') + '</a>'; p.appendChild(a); })
          .finally(function () { p.classList.remove('is-loading'); p.removeAttribute('aria-busy'); });
      }
    });
  }

  function scents(blk) {
    if (!once(blk)) return;
    var btns = $$('[data-scent]', blk), q = function (s) { return blk.querySelector(s); };
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        var o = JSON.parse(b.dataset.scent);
        blk.style.setProperty('--stage', o.stage); blk.style.setProperty('--accent', o.accent);
        var im = q('[data-scent-img]'); if (im && o.photo) { im.removeAttribute('srcset'); im.src = o.photo; im.alt = o.photoAlt || ''; im.style.objectPosition = o.pos || '50% 50%'; }
        var pk = q('[data-scent-pack]'); if (pk && o.pack) { pk.removeAttribute('srcset'); pk.src = o.pack; pk.alt = o.title; }
        $$('[data-scent-link]', blk).forEach(function (a) { a.href = o.url; });
        var nm = q('[data-scent-name]'); if (nm) nm.textContent = o.name;
        var nt = q('[data-scent-notes]'); if (nt) nt.textContent = o.notes;
        var pr = q('[data-scent-price]'); if (pr) pr.textContent = o.price;
        var inp = q('[data-scent-form] input[name="id"]'); if (inp) inp.value = o.variant;
        var btn = q('[data-scent-form] [type="submit"]');
        if (btn) { btn.setAttribute('aria-label', 'Add ' + o.title + ' to bag, ' + o.price); btn.disabled = !o.available; btn.querySelector('span').textContent = o.available ? 'Add to bag' : 'Coming soon'; }
      });
    });
  }

  function addAll(b) {
    if (!once(b)) return;
    b.addEventListener('click', function () {
      var items; try { items = JSON.parse(b.dataset.items); } catch (e) { return; }
      if (!items.length || b.getAttribute('aria-disabled') === 'true') return;
      var label = b.querySelector('span'), txt = label.textContent, msg = b.parentNode.querySelector('.kh-addall__msg');
      b.setAttribute('aria-disabled', 'true'); b.classList.add('btn--loading'); if (msg) msg.textContent = '';
      fetch(root() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          d.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          b.classList.add('is-done'); label.textContent = 'Added';
          setTimeout(function () { b.classList.remove('is-done'); label.textContent = txt; }, 2500);
        })
        .catch(function (e) { if (msg) msg.textContent = (e && (e.description || e.message)) || 'Could not add these items. Please try again.'; d.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })); })
        .finally(function () { b.classList.remove('btn--loading'); b.removeAttribute('aria-disabled'); });
    });
  }

  function openNow(el) {
    if (!once(el)) return;
    try {
      var open = +el.dataset.open || 10, close = +el.dataset.close || 20;
      var h = parseInt(new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', hour12: false }).format(new Date()), 10) % 24;
      var isOpen = h >= open && h < close, fmt = function (x) { return (x % 12 || 12) + (x < 12 ? 'am' : 'pm'); };
      el.classList.toggle('is-closed', !isOpen);
      el.querySelector('span').textContent = isOpen ? 'Open now · until ' + fmt(close) : 'Closed now · opens ' + fmt(open);
    } catch (e) {}
  }

  function more(b) {
    if (!once(b)) return;
    b.hidden = false;
    b.addEventListener('click', function () { var t = d.getElementById(b.getAttribute('aria-controls')); var on = t.classList.toggle('kh-clamp3'); b.setAttribute('aria-expanded', !on); b.textContent = on ? 'Read more' : 'Show less'; });
  }

  function init(r) {
    $$('[data-kh-hero]', r).forEach(hero);
    $$('[data-kh-shelf]', r).forEach(shelf);
    $$('[data-kh-scents]', r).forEach(scents);
    $$('[data-kh-addall]', r).forEach(addAll);
    $$('[data-open-now]', r).forEach(openNow);
    $$('[data-kh-more]', r).forEach(more);
  }
  window.kcHome = { init: init };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
